import StandardMaterial from './StandardMaterial.js';
import SpecularGlossinessMixin from '../SpecularGlossinessMixin.js';


class StandardSpecularGlossinessMaterial extends SpecularGlossinessMixin(StandardMaterial) {
}

export default StandardSpecularGlossinessMaterial;
